import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';

interface MacAppPromotionBannerProps {
  variant: 'dictation' | 'recorder' | 'meetings';
}

// TODO: Set to true to re-enable the banner
const BANNER_ENABLED = false;

const MacAppPromotionBanner: React.FC<MacAppPromotionBannerProps> = ({
  variant,
}) => {
  const [showBanner, setShowBanner] = useState(false);

  const messages = {
    dictation: 'Use hotkeys and dictate anywhere with our Mac app',
    recorder: 'Record your screen with one click using our Mac app',
    meetings: 'Record your meetings with a tap using our Mac app',
  };

  const storageKey = `macAppPromoBanner${variant.charAt(0).toUpperCase() + variant.slice(1)}Dismissed`;

  useEffect(() => {
    // Check if user is on Mac
    const isMac = /Mac|iPod|iPhone|iPad/.test(navigator.platform);

    // Check if banner was previously dismissed for this variant
    const wasDismissed = localStorage.getItem(storageKey) === 'true';

    if (BANNER_ENABLED && isMac && !wasDismissed) {
      setShowBanner(true);
    }
  }, [storageKey]);

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem(storageKey, 'true');
  };

  const handleGetApp = () => {
    const url = new URL('/desktop', window.location.origin);
    url.searchParams.append('utm_source', 'web_app');
    url.searchParams.append('utm_medium', 'promotion_banner');
    url.searchParams.append('utm_campaign', `mac_app_${variant}`);
    url.searchParams.append('utm_content', 'get_mac_app_button');

    window.open(url.toString(), '_blank');
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="flex items-center justify-between p-3 mb-4 bg-muted/50 rounded-md">
      <p className="text-sm text-muted-foreground">{messages[variant]}</p>
      <div className="flex items-center gap-2">
        <Button size="sm" onClick={handleGetApp} className="h-8">
          Get Mac App
        </Button>
        <Button
          size="sm"
          variant="ghost"
          onClick={handleDismiss}
          className="h-8 w-8 p-0 text-muted-foreground hover:text-foreground text-base"
        >
          ✕
        </Button>
      </div>
    </div>
  );
};

export default MacAppPromotionBanner;
